module.exports = __webpack_public_path__ + "img/zhlc-2.9586ca7f.png";